import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Scale } from "lucide-react";
import api from "@/lib/api";
import { invalidateLegalInfo } from "@/hooks/useLegalInfo";

const FIELDS = [
  ["company_name", "Nombre o razón social *", "Mi Empresa S.L."],
  ["tax_id", "NIF / CIF *", "B12345678"],
  ["address", "Dirección completa *", "C/ Mayor 1, 28001 Madrid"],
  ["email", "Email de contacto (derechos RGPD) *", "privacidad@miempresa.com"],
  ["dpo_email", "Email del DPD (opcional)", "dpo@miempresa.com"],
  ["registry", "Registro Mercantil (si es sociedad)", "R.M. Madrid, Tomo 1234, Folio 56, Hoja M-78901"],
  ["jurisdiction_city", "Ciudad de los juzgados", "Madrid"],
  ["website", "Web", "https://presupuestosrapidonline.com"],
];

export function LegalSettingsSection() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/legal-info").then((r) => setForm(r.data)); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/legal-info", form);
      setForm(data);
      invalidateLegalInfo(data);
      toast.success("Datos legales guardados · ya aparecen en las páginas legales");
    } catch (err) { toast.error(err?.response?.data?.detail || "Error guardando"); }
    finally { setSaving(false); }
  };

  if (!form) return null;
  return (
    <form onSubmit={save} className="mt-4 border border-slate-200 bg-white p-6" data-testid="admin-legal-section">
      <div className="flex items-center gap-3 mb-2">
        <Scale className="w-5 h-5 text-slate-400" />
        <h3 className="font-display font-bold text-xl">Datos legales del responsable</h3>
      </div>
      <p className="text-sm text-slate-500 mb-5">
        Se muestran en el <Link to="/aviso-legal" className="text-orange-600 underline">Aviso Legal</Link>, la{" "}
        <Link to="/politica-de-privacidad" className="text-orange-600 underline">Política de Privacidad</Link>, la de Cookies, los formularios y los certificados de borrado.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, ph]) => (
          <div key={k} className={k === "address" || k === "registry" ? "sm:col-span-2" : ""}>
            <label className="kbar block">{label}</label>
            <input data-testid={`legal-${k}`} value={form[k] || ""} placeholder={ph}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="w-full h-11 mt-2 px-3 border border-slate-200 outline-none focus:border-orange-600 text-sm" />
          </div>
        ))}
      </div>
      <div className="flex items-center gap-4 mt-5 flex-wrap">
        <button disabled={saving} data-testid="legal-save" className="btn-brand h-11 px-5">{saving ? "Guardando…" : "Guardar datos legales"}</button>
        {form.updated_at && <span className="text-xs text-slate-500">Última actualización: {new Date(form.updated_at).toLocaleString("es-ES")}</span>}
      </div>
    </form>
  );
}
